import { PaysafeFieldConfig } from './paysafe-field-config.interface';
import { PaysafeFormField } from './paysafe-form-field.enum';

export interface PaysafeExpiryDateFieldConfig extends PaysafeFieldConfig {
  fieldName: PaysafeFormField.ExpiryDate;
}
